import React from "react";
import Grid from "@mui/material/Grid";
import Title from "./elements/Title";
import Description from "./elements/Description";
import {
  BannerContainer,
  TitleBox,
  DescriptionWrapper,
} from "./styled/Banner.styled";
export default function Banner({ small, ...props }) {
  return (
    <BannerContainer small={small}>
      <Grid container spacing={0}>
        <Grid item xs={12} md={6}>
          <TitleBox>
            <Title />
            {!small && (
              <>
                <DescriptionWrapper>
                  <Description />
                </DescriptionWrapper>
              </>
            )}
          </TitleBox>
        </Grid>
        <Grid item xs={12} md={6}></Grid>
      </Grid>
    </BannerContainer>
  );
}
